import { LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ADD_ADVERT } from 'shared/constants/smb/links';
import clsx from 'clsx';

export const PreFooterBanner: React.FC = () => {
  const device = useDeviceType();

  const btnSize = device === 'phone' ? 'M' : 'L';

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Начать работать с Циан</div>
      <div className={styles['btn']}>
        <Theme theme="colored">
          <LinkButton href={ADD_ADVERT} target="_blank" rel="noopener noreferrer" size={btnSize} fullWidth>
            Разместить объявление
          </LinkButton>
        </Theme>
      </div>
    </div>
  );
};
